'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserClientPortal } from '../../Entities/User/UserClientPortal';
import { UserClientPortalCollection } from '../../Collections/User/UserClientPortalCollection';

export class UserClientPortalRepository extends CoreRepository {
  public getUserClientPortals(userId: number, options: object = {}) {
    return this.webAPI.getUserClientPortals(userId, options).then((response) => {
      const collection = new UserClientPortalCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserClientPortal();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getUserClientPortal(userClientPortalId: number, options: object = {}) {
    if (!options) {
      options = {};
    }

    return this.webAPI.getUserClientPortal(userClientPortalId, options).then((response) => {
      const userClientPortal = new UserClientPortal();
      userClientPortal.hydrate(response);

      return userClientPortal;
    });
  }

  public addUserClientPortal(userId: number, payload: any[]) {
    return this.webAPI.addUserClientPortal(userId, payload).then((response) => {
      const item = new UserClientPortal();
      item.hydrate(response);

      return item;
    });
  }

  public updateUserClientPortal(userId: number, clientPortalId: number, payload: any[]) {
    return this.webAPI.updateUserClientPortal(userId, clientPortalId, payload).then((response) => {
      return response;
    });
  }

  public deleteUserClientPortal(userId: number, clientPortalId: number) {
    return this.webAPI.deleteUserClientPortal(userId, clientPortalId).then((response) => {
      return response;
    });
  }
}
